import { apiConf as api } from 'commons';

export const fetchCustomers = (platform) => {
  return api.superFetch({ url: "organisations", platform });
};
